var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 8C14.6667 11.68 11.68 14.6667 8 14.6667C4.32 14.6667 2.07333 10.96 2.07333 10.96M2.07333 14.2933V10.96H5.08667M1.33333 8C1.33333 4.32 4.29333 1.33333 8 1.33333C12.4467 1.33333 14.6667 5.04 14.6667 5.04M11.7067 5.04H14.6667V1.70667",
    stroke: "#046242",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.671b2cd6fbeae26db878fb3ba381fff5.svg";
export { ForwardRef as ReactComponent };